<template>
    <va-create-layout>
        <SellerReviewEnrollmentPaymentEvent-form
            :title="title"
            :item="item"
        ></SellerReviewEnrollmentPaymentEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
